<template>
  <div class="pb-3" >
    <va-card :title="$t(`games.cards.${titleCard}`)">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="row">
            <div class="flex md12">
              <div class="form-group mt-3 mb-3">
                <va-select
                  :label="$t('games.forms.championshipLabel')"
                  v-model="championship"
                  textBy="name"
                  keyBy='id'
                  no-clear
                  searchable
                  :placeholder="$t('games.forms.championshipPlaceholder')"
                  :noOptionsText="$t('games.forms.championshipNoOption')"
                  maxHeight='200px'
                  :options="championships.length > 0 ? championships : []"
                />
              </div>
              <div class="form-group mt-3 mb-3">
                <va-select
                  :label="$t('games.forms.club1Label')"
                  v-model="club1"
                  textBy="name"
                  keyBy='id'
                  no-clear
                  searchable
                  :placeholder="$t('games.forms.club1Placeholder')"
                  :noOptionsText="$t('games.forms.club1NoOption')"
                  maxHeight='200px'
                  :options="clubs1.length > 0 ? clubs1 : []"
                />
              </div>
              <div class="form-group mt-3 mb-3">
                <va-select
                  :label="$t('games.forms.club2Label')"
                  v-model="club2"
                  textBy="name"
                  keyBy='id'
                  no-clear
                  searchable
                  :placeholder="$t('games.forms.club2Placeholder')"
                  :noOptionsText="$t('games.forms.club2NoOption')"
                  maxHeight='200px'
                  :options="clubs2.length > 0 ? clubs2 : []"
                />
              </div>
              <ValidationProvider rules="required" name="Data e Hora do Jogo" v-slot="{ errors }">
                <va-date-picker
                  :label="$t('games.forms.datetimeLabel')"
                  :placeholder="$t('games.forms.datetimePlaceholder')"
                  :config="{enableTime: true, dateFormat: 'Y-m-d H:i:S', time_24hr: true}"
                  :success="errors.length == 0"
                  :error="errors.length > 0"
                  :messages="errors"
                  v-model="game.datetime"
                />
              </ValidationProvider>
              <div class="d-flex mt-3">
                <va-button
                  type="submit"
                  :disabled="buttonSubmitDisabled"
                  color="success"
                  class="my-0">
                  {{ textSubmit }}
                </va-button>
                <va-button
                  type="button"
                  class="my-0"
                  color="danger"
                  @click="cancel">
                  {{ $t("forms.cancel") }}
                </va-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
export default {
  name: 'GamesAddUpdate',
  props: {
    page: {
      type: Number,
      required: true,
    },
    titleCard: {
      type: String,
      required: true,
    },
    updateData: {
      required: true,
    },
    week: {
      default: null,
    },
  },
  data () {
    return {
      game: {
        club1Id: '',
        club2Id: '',
        championshipId: '',
        datetime: '',
      },
      championship: '',
      club1: '',
      club2: '',
      championships: [],
      clubs1: [],
      clubs2: [],
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
    }
  },
  created () {
    this.game.club1Id = ''
    this.game.club2Id = ''
    this.game.championshipId = ''
    this.game.datetime = ''
    if (this.updateData !== null) {
      this.game_get(this.updateData)
    }
  },
  watch: {
    updateData (value) {
      if (this.updateData !== null) {
        this.game_get(this.updateData)
      } else {
        this.game.club1Id = ''
        this.game.club2Id = ''
        this.game.championshipId = ''
        this.game.datetime = ''
      }
    },
    championship (value) {
      if (value !== '') {
        this.game.championshipId = value.id
      }
    },
    club1 (value) {
      if (value !== '') {
        this.game.club1Id = value.id
      }
    },
    club2 (value) {
      if (value !== '') {
        this.game.club2Id = value.id
      }
    },
  },
  apollo: {
    championships: {
      query: gql`
      query myquery {
        championships: championship(order_by: {name: asc}, where: {id: {_neq: 1}}) {
          id
          name
        }
      }
      `,
      result ({ data, loading }) {
        if (!loading) {
          if (data.championships.length > 0 && this.championship === '') {
            this.championship = Object.assign({}, data.championships[0])
          }
        }
      },
    },
    clubs: {
      query: gql`
      query myquery {
        clubs: club(order_by: {name: asc}, where: {id: {_neq: 1}}) {
          id
          name
        }
      }
      `,
      manual: true,
      result ({ data, loading }) {
        if (!loading) {
          this.clubs1 = data.clubs
          this.clubs2 = data.clubs
          if (data.clubs.length > 0 && this.club1 === '' && this.club2 === '') {
            this.club1 = Object.assign({}, data.clubs[0])
            this.club2 = Object.assign({}, data.clubs[1])
          }
        }
      },
    },
    weeks: {
      query: gql`
      query myquery {
        weeks: week(order_by: {id: desc}) {
          id
          name
        }
      }
      `,
      result ({ data, loading }) {
        if (!loading) {
          if (data.weeks.length > 0 && this.week === '') {
            this.week = Object.assign({}, data.weeks[0])
          }
        }
      },
    },
  },
  methods: {
    cancel () {
      this.$emit('showAdd', false)
    },
    game_get (data) {
      Object.keys(data).forEach((value, key) => {
        if (value !== '__typename') {
          if (value === 'championship') {
            this.championship = data[value]
          } else if (value === 'club1') {
            this.club1 = data[value]
          } else if (value === 'club2') {
            this.club2 = data[value]
          } else {
            this.game[value] = data[value]
          }
        }
      })
    },
    onSubmit () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')
      const { championshipId, club1Id, club2Id, datetime } = this.game
      const self = this
      this.$apollo
        .mutate({
          mutation: (
            this.week === null ? (this.updateData !== null ? gql`
                mutation MyMutation( $datetime: timestamp!, $club2_id: Int!, $club1_id: Int!, $championship_id: Int!, $id: Int!) {
                  update_game_by_pk(pk_columns: {id: $id}, _set: {datetime: $datetime, championship_id: $championship_id, club1_id: $club1_id, club2_id: $club2_id}) {
                    id
                  }
                }
                ` : gql`
                mutation MyMutation($datetime: timestamp!, $club2_id: Int!, $club1_id: Int!, $championship_id: Int!) {
                  insert_game(objects: {datetime: $datetime, championship_id: $championship_id, club1_id: $club1_id, club2_id: $club2_id}) {
                    affected_rows
                  }
                }
                `
            ) : (this.updateData !== null ? gql`
                mutation MyMutation($week_id: Int!, $datetime: timestamp!, $club2_id: Int!, $club1_id: Int!, $championship_id: Int!, $id: Int!) {
                  update_game_by_pk(pk_columns: {id: $id}, _set: {datetime: $datetime, championship_id: $championship_id, club1_id: $club1_id, club2_id: $club2_id, week_id: $week_id}) {
                    id
                  }
                }
                ` : gql`
                mutation MyMutation($week_id: Int!, $datetime: timestamp!, $club2_id: Int!, $club1_id: Int!, $championship_id: Int!) {
                  insert_game(objects: {datetime: $datetime, championship_id: $championship_id, club1_id: $club1_id, club2_id: $club2_id, week_id: $week_id}) {
                    affected_rows
                  }
                }
                `
            )),
          variables: this.week === null ? (this.updateData !== null ? {
            championship_id: championshipId,
            club1_id: club1Id,
            club2_id: club2Id,
            datetime: datetime,
            id: this.game.id,
          } : {
            championship_id: championshipId,
            club1_id: club1Id,
            club2_id: club2Id,
            datetime: datetime,
          }) : (this.updateData !== null ? {
            championship_id: championshipId,
            club1_id: club1Id,
            club2_id: club2Id,
            week_id: this.week,
            datetime: datetime,
            id: this.game.id,
          } : {
            championship_id: championshipId,
            club1_id: club1Id,
            club2_id: club2Id,
            week_id: this.week,
            datetime: datetime,
          })
          ,
        })
        .then(data => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.game.club1Id = ''
          self.game.club2Id = ''
          self.game.championshipId = ''
          self.game.weekId = ''
          self.$emit('showAdd', false)
          self.$emit('showMore', self.page)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.successUpdate' : 'toasts.successCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.game.club1Id = ''
          self.game.club2Id = ''
          self.game.championshipId = ''
          self.game.weekId = ''
          self.$emit('showAdd', false)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.errorUpdate' : 'toasts.errorCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style lang="scss">
.va-message-list {
  &__message {
    vertical-align: middle;
    font-size: $font-size-mini;
    color: rgb(248, 112, 109);
  }
}

.position {
  position: relative;
}
</style>
